import axios from "@/libs/netAxios"
import {
  IGetMerchOrdersRequest,
  IGetMerchOrdersWithCountRequest,
} from "@/types/request/IGetMerchOrdersRequest"
import { OrderStatus, UserParty } from "../../types/enum/OrderEnum"
import { UserRatingDto } from "@/types/interface/User/UserTypes"
import qs from "qs"
import { IOrderCountForStatus } from "@/types/interface/IOrderDto"
import store from "@/store"

export const getOrderById = async (
  orderId: string,
  showLoadding: boolean = true
) => {
  showLoadding ? store.commit("handleShowLoading", true) : ""
  try {
    let { status, data } = await axios.request({
      method: "GET",
      url: `/api/Order/${orderId}`,
    })

    if (status === 200) {
      let orderList = [...store.state.orderList]
      let historyOrderList = [...store.state.historyOrder]
      let orderIndex = orderList.findIndex((x) => x.id === orderId)
      let historyOrderIndex = historyOrderList.findIndex(
        (x) => x.id === orderId
      )
      if (orderIndex > -1) {
        orderList.splice(orderIndex, 1, data)
        store.commit("handleOrderList", orderList)
      }
      if (historyOrderIndex > -1) {
        historyOrderList.splice(historyOrderIndex, 1, data)
        store.commit("handleHistoryOrder", historyOrderList)
      }
    }
  } catch (error) {
    // todo
  } finally {
    store.commit("handleShowLoading", false)
  }
}

export const getOrders = (
  params: IGetMerchOrdersRequest,
  headers?: { merchId: string }
) => {
  return axios.request({
    headers,
    method: "GET",
    url: "/api/Order/merchorders",
    params,
    paramsSerializer: (params) => {
      return qs.stringify(params, { indices: false })
    },
  })
}

export const getOrdersCount = async (
  params: IGetMerchOrdersRequest,
  headers?: { merchId: string }
): Promise<IOrderCountForStatus> => {
  return (
    await axios.request({
      headers,
      method: "GET",
      url: "/api/Order/merchorderscount",
      params,
      paramsSerializer: (params) => {
        return qs.stringify(params, { indices: false })
      },
    })
  ).data.orderCountForStatus
}

export const updateOrderStatus = (
  merchId: string,
  orderId: string,
  orderStatus: OrderStatus,
  rejectReason?: string,
  merchDecideConfirmedPickupTime?: string
) => {
  return axios.request({
    headers: {
      merchId,
    },
    method: "POST",
    url: "/api/Order/status/update",
    data: {
      orderId,
      orderStatus,
      rejectReason,
      commandFrom: UserParty.Merchant,
      merchDecideConfirmedPickupTime,
    },
  })
}

export const merchCancelOrder = (
  merchId: string,
  orderId: string,
  reason: string,
  orderItemIds: string[]
) => {
  return axios.request({
    headers: {
      merchId,
    },
    method: "POST",
    url: "/api/Order/merchant/cancellation/request",
    data: {
      orderId,
      reason,
      orderItemIds,
    },
  })
}

export const orderAcceptRefunRequest = (
  merchId: string,
  orderId: string,
  merchConfirmationRefundPercentage: number
) => {
  return axios.request({
    headers: {
      merchId,
    },
    method: "POST",
    url: "/api/Order/accept/cancellation/request",
    data: {
      orderId,
      merchConfirmationRefundPercentage,
    },
  })
}

export const getRefundableAmount = (
  merchId: string,
  OrderId: string,
  MerchConfirmationRefundPercentage: number
) => {
  return axios.request({
    headers: {
      merchId,
      "Content-Type": "application/json",
    },
    method: "GET",
    url: "/api/Order/cancellation/getRefundableAmount",
    params: {
      OrderId,
      MerchConfirmationRefundPercentage,
    },
  })
}

export const rejectCancelRequest = (
  merchId: string,
  orderId: string,
  reason: string
) => {
  return axios.request({
    headers: {
      merchId,
    },
    method: "POST",
    url: "/api/Order/reject/cancellation/request",
    data: {
      orderId,
      reason,
    },
  })
}

export const orderOfflinePayRequest = (merchId: string, orderId: string) => {
  return axios.request({
    headers: {
      merchId,
    },
    method: "POST",
    url: "/api/Order/pay/offline",
    data: {
      orderId,
    },
  })
}

export const getRefundOrderList = (merchId: string) => {
  return axios.request({
    headers: {
      merchId,
    },
    method: "GET",
    url: "/api/Order/merchOrderCancellationRequests",
    params: {
      merchId,
    },
  })
}

export const getOrderDetail = (merchId: string, orderId: string) => {
  return axios.request({
    headers: {
      merchId,
    },
    method: "GET",
    url: `/api/Order/${orderId}`,
  })
}

export const getOrderTimeRecord = (merchId: string, orderId: string) => {
  return axios.request({
    headers: {
      merchId,
    },
    method: "GET",
    url: `/api/Order/audits/${orderId}`,
  })
}

export const getUserRatingForOrder = async (
  merchId: string,
  orderId: string
): Promise<UserRatingDto> => {
  return (
    await axios.request({
      headers: {
        merchId,
      },
      method: "POST",
      url: "/api/User/rating",
      data: {
        orderId,
      },
    })
  ).data
}

export const refundOrderForCustomer = (
  merchId: string,
  orderId: string,
  reason: string,
  userRequestRefundPercentage: number,
  orderItemIds: string[]
) => {
  return axios.request({
    headers: {
      merchId,
    },
    method: "POST",
    url: "/api/Order/merchant/complain",
    data: {
      orderId,
      reason,
      userRequestRefundPercentage,
      orderItemIds,
    },
  })
}

export const getOrdersWithCount = (
  merchId: string,
  params: IGetMerchOrdersWithCountRequest
) => {
  return axios.request({
    headers: { merchId },
    method: "GET",
    url: "/api/Order/merchOrdersWhitCount",
    params,
    paramsSerializer: (params) => {
      return qs.stringify(params, { indices: false })
    },
  })
}
